import ReactGA from "react-ga";

ReactGA.initialize("UA-23695496-1");
ReactGA.pageview(window.location.pathname + window.location.search);
